import React, { Fragment, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import * as Yup from 'yup';
import { Formik } from 'formik';

import {
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
    RadioGroup,
    Grid,
    Radio,
    Paper,
    FormLabel,
    FormControl,
    FormControlLabel,
    InputLabel,
    Select,
    MenuItem
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper
    },
    fieldset: {
        margin: 8
    }
}));

const Create = ({ item, open, closeCreation, createValues, dependencies, updateDependencies }) => {

    const classes = useStyles();

    const changeExternalGroup = (event, values) => {
        item.externalgroup = event.target.value;
        values.externalgroup = event.target.value;
        updateDependencies(values);
    }

    useEffect(() => {
        if (!dependencies.loaded) {
            updateDependencies(item);
        }
        return
    }, []);

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="sm" fullWidth >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Usuário
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                firstname: Yup.string().max(255).required('Nome é obrigatório'),
                                lastname: Yup.string().max(255).required('Sobrenome é o obrigatório'),
                                password: Yup.string().max(255).required('Senha é obrigatória'),
                                login: Yup.string().max(255).required('Login é obrigatório'),
                                profile: Yup.string().max(3).required('Perfil é obrigatório'),
                                email: Yup.string().email('Formato de email está incorreto').max(255).required('Email é obrigatorio'),
                                externalgroup: Yup.string().required('Definição de Acesso a empresa é obrigatório')
                            })
                        }
                        onSubmit={(values, formik) => {
                            createValues(values);
                            formik.setSubmitting(false);
                        }}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid
                                    container
                                    spacing={2}
                                >
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.firstname && errors.firstname)}
                                            fullWidth
                                            label="Nome"
                                            margin="normal"
                                            name="firstname"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.firstname}
                                            variant="outlined"
                                            inputProps={{
                                                name: 'firstname',
                                                id: 'firstname',
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.lastname && errors.lastname)}
                                            fullWidth
                                            label="Sobrenome"
                                            margin="normal"
                                            name="lastname"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.lastname}
                                            variant="outlined"
                                            inputProps={{
                                                name: 'lastname',
                                                id: 'lastname',
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.phone1 && errors.phone1)}
                                            fullWidth
                                            label="Fixo"
                                            margin="none"
                                            name="phone1"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.phone1}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.phone2 && errors.phone2)}
                                            fullWidth
                                            label="Celular"
                                            margin="none"
                                            name="phone2"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.phone2}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.email && errors.email)}
                                            fullWidth
                                            label="Email"
                                            margin="none"
                                            name="email"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            type="email"
                                            value={values.email}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.login && errors.login)}
                                            fullWidth
                                            label="Login"
                                            margin="none"
                                            name="login"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.login}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.password && errors.password)}
                                            fullWidth
                                            label="Senha"
                                            margin="none"
                                            name="password"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            type="password"
                                            value={values.password}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid item
                                        md={12}
                                        xs={12}>
                                        <FormControl variant="outlined" fullWidth>
                                            <InputLabel shrink htmlFor="externalgroup">Usuário é Técnico de um departamento?</InputLabel>
                                            <Select notched
                                                error={Boolean(touched.externalgroup && errors.externalgroup)}
                                                required
                                                fullWidth
                                                label="Usuário é Técnico de um departamento?"
                                                variant="outlined"
                                                id="externalgroup"
                                                name="externalgroup"
                                                value={values.externalgroup}
                                                onChange={(e) => { changeExternalGroup(e, values) }}
                                                inputProps={{
                                                    name: 'externalgroup',
                                                    id: 'externalgroup',
                                                }}
                                            >
                                                <MenuItem key={-1} value={-1}>Não</MenuItem>
                                                {dependencies.externalGroups.map((eg) => (
                                                    <MenuItem key={eg.id} value={eg.id}>{eg.nome}</MenuItem>
                                                ))}

                                            </Select>
                                        </FormControl>
                                    </Grid>


                                    <Grid item
                                        md={12}
                                        xs={12}>
                                        <FormControl variant="outlined" fullWidth>
                                            <InputLabel shrink htmlFor="externalid">Qual é o nome do Técnico?</InputLabel>
                                            <Select notched
                                                error={Boolean(touched.externalid && errors.externalid)}
                                                required={values.externalgroup != -1}
                                                fullWidth
                                                label="Qual é o nome do Técnico?"
                                                variant="outlined"
                                                id="externalid"
                                                name="externalid"
                                                value={values.externalid}
                                                onChange={handleChange}
                                                inputProps={{
                                                    name: 'externalid',
                                                    id: 'externalid',
                                                }}
                                            >
                                                <MenuItem key={-1} value={-1}>Selecione uma opção abaixo</MenuItem>
                                                {dependencies.externalIds.map((eid) => (
                                                    <MenuItem key={eid.id} value={eid.id}>{eid.nome}</MenuItem>
                                                ))}

                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>
                                        <Paper variant="outlined" rounded >
                                            <FormControl component="fieldset" required fullWidth >
                                                <FormLabel style={{ padding: 10 }} error={Boolean(touched.profile && errors.profile)}>
                                                    <b>Perfis de Acesso</b>
                                                </FormLabel>

                                                <Divider></Divider>

                                                <RadioGroup
                                                    required
                                                    className={classes.fieldset}
                                                    name="profile"
                                                    value={values.profile}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}>

                                                    {dependencies.profiles.map(profile => {
                                                        return (localStorage.getItem('profile') != 'ENG' && profile.id == 'ENG') ?
                                                            <div></div> :
                                                            <FormControlLabel value={profile.id} control={<Radio />} label={profile.id + " - " + profile.name} />
                                                    })}

                                                </RadioGroup>
                                            </FormControl>
                                        </Paper>
                                    </Grid>
                                </Grid>
                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeCreation() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Create;
